var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiNav3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.085,
    height: 23.953,
    viewBox: "0 0 23.085 23.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106158",
    "data-name": "Path 106158",
    d: "M21.338,4.081a2.571,2.571,0,0,0-1,.162L13.09,6.86H8.8a2.591,2.591,0,0,0-2.6,2.6V25.436a2.591,2.591,0,0,0,2.6,2.6H19.782a2.614,2.614,0,0,0,2.557-2.157l5.213-1.758a2.536,2.536,0,0,0,1.458-1.338,2.49,2.49,0,0,0,.12-2l-5.473-15a2.535,2.535,0,0,0-1.338-1.458A2.46,2.46,0,0,0,21.338,4.081Zm-.05,1.176a1.326,1.326,0,0,1,.532.125,1.353,1.353,0,0,1,.719.8l.639,1.738a3.271,3.271,0,0,0-2.4-1.059H16.586l4.155-1.518A1.6,1.6,0,0,1,21.288,5.257ZM8.8,8.058H19.782a1.39,1.39,0,0,1,1.4,1.4V25.436a1.39,1.39,0,0,1-1.4,1.4H8.8a1.39,1.39,0,0,1-1.4-1.4V9.456A1.39,1.39,0,0,1,8.8,8.058Zm15.18,2.117L27.991,21.2a1.305,1.305,0,0,1-.04,1.058,1.375,1.375,0,0,1-.779.719l-3.2,1.079ZM10.254,15.848a.6.6,0,1,0,0,1.2h8.189a.6.6,0,1,0,0-1.2Zm0,3a.6.6,0,1,0,0,1.2h8.189a.6.6,0,0,0,0-1.2Zm0,3a.6.6,0,1,0,0,1.2h5.293a.6.6,0,1,0,0-1.2Z",
    transform: "translate(-6.199 -4.079)",
    fill: "#080e15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiNav3);
export default __webpack_public_path__ + "static/media/visionai_nav3.a0f45c9fcf8fca880ffb9ebd6856d1e9.svg";
export { ForwardRef as ReactComponent };